module.exports = __webpack_public_path__ + "img/query-new-2.faa10793.png";